<template>
  <div class="d-flex align-items-end item-text-testimonial">

    <div class="container">
      <img height="350" class="d-none d-md-flex pl-5 position-absolute" src="../../assets/img/home/prof_marcio.png">
      <div class="w-100 px-5 pt-5 mt-5 pb-5 row text-center mx-0 " style="height: 300px;">
        <div class="col-md-5 d-none d-md-flex justify-content-xl-center align-items-center">
        </div>
        <div class="col p-0 d-flex justify-content-center justify-content-md-start align-items-center">
          <h5 class="text-light text-light px-5">«Sempre gostei de dar aula e com essa plataforma estou conseguindo fazer o que mais amo que é ensinar » Marcio Guidoni</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
